import Lightbox from "yet-another-react-lightbox";
import Captions from "yet-another-react-lightbox/plugins/captions";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";

// Full-screen image viewer for the carousels, on yet-another-react-lightbox
// (maintained, React 19). Replaces react-image-lightbox with its behaviour:
// wrap-around prev/next, caption under the image, click outside the image to
// close, Esc/arrow keys, no zoom — and its look: 85% black backdrop with the
// page faintly visible, left-aligned caption.
interface ImageLightboxProps {
  open: boolean;
  images: string[];
  captions?: (string | null | undefined)[];
  index: number;
  onClose: () => void;
  onIndexChange: (index: number) => void;
}

export default function ImageLightbox({ open, images, captions = [], index, onClose, onIndexChange }: ImageLightboxProps) {
  const slides = images.map((src, i) => ({ src, description: captions[i] || undefined }));
  return (
    <Lightbox
      open={open}
      close={onClose}
      index={index}
      slides={slides}
      plugins={[Captions]}
      carousel={{ finite: false }}
      controller={{ closeOnBackdropClick: true }}
      captions={{ descriptionTextAlign: "start" }}
      styles={{ root: { "--yarl__color_backdrop": "rgba(0, 0, 0, 0.85)" } }}
      on={{ view: ({ index: current }) => onIndexChange(current) }}
    />
  );
}
